import React from "react";

import useCheckoutStepsOffersContext from "@payment/pages/CheckoutStepsOffers/provider";

import { ArrowRightIcon, Header, Number, Step, StepContainer } from "./styles";

const StepsHeader = () => {
  const { steps, setSteps, offer, userCanTrial } =
    useCheckoutStepsOffersContext();

  return (
    <Header>
      <StepContainer active={steps === 0} onClick={() => setSteps(0)}>
        <Number>1</Number>

        <Step>Informações</Step>
      </StepContainer>

      <ArrowRightIcon />

      <StepContainer active={steps === 1}>
        <Number>2</Number>

        <Step>Pagamento</Step>
      </StepContainer>
    </Header>
  );
};

export default StepsHeader;
